<template>
  <div class="bbr-workouts--draft-workouts">
    <workouts-list-table
      :workouts="workouts"
      :loading="loading"
      :meta="listMeta"
      @goTo="showDetails"
      @loadMore="loadMore"
    />
  </div>
</template>

<script>
import WorkoutsListTable from '../components/WorkoutsListTable'
import { mapState, mapActions, mapMutations } from 'vuex'
import Event from '@/services/eventBus'

export default {
  name: 'DraftWorkouts',

  components: {
    WorkoutsListTable,
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapState({
      filter: (state) => state.workouts.filter,
      workouts: (state) => state.workouts.drafts.list,
      listMeta: (state) => state.workouts.drafts.listMeta,
    }),
  },

  created() {
    this.setFilter({ active: false })

    if (!this.filter.search) {
      this.clearList()
      this.fetchWorkouts()
    }

    Event.$on('new-workout-added', (type) => {
      if (!type) {
        this.fetchWorkouts()
      }
    })
  },

  methods: {
    ...mapActions({
      getWorkouts: 'workouts/getWorkouts',
    }),

    ...mapMutations({
      setFilter: 'workouts/setFilter',
      clearList: 'workouts/clearList',
    }),

    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchWorkouts(this.listMeta.current_page + 1)
      }
    },

    async fetchWorkouts(page = 1) {
      if (this.loading) return

      let active = false
      let search = this.filter.search
      let params = { page, search, active }

      this.loading = true

      await this.getWorkouts(params)

      this.loading = false
    },

    showDetails(workoutId) {
      this.$router.push({
        name: 'new.workout',
        params: {
          id: workoutId,
        },
      })
    },
  },
}
</script>
